import { logger } from '@sentry/utils';
import { DEBUG_BUILD } from '../debug-build.js';
import { spanToJSON, spanIsSampled, getRootSpan } from '../utils/spanUtils.js';

/**
 * Print a log message for a started span.
 */
function logSpanStart(span) {
  if (!DEBUG_BUILD) return;
  const {
    description = '< unknown name >',
    op = '< unknown op >',
    parent_span_id: parentSpanId
  } = spanToJSON(span);
  const {
    spanId
  } = span.spanContext();
  const sampled = spanIsSampled(span);
  const rootSpan = getRootSpan(span);
  const isRootSpan = rootSpan === span;
  const header = "[Tracing] Starting ".concat(sampled ? 'sampled' : 'unsampled', " ").concat(isRootSpan ? 'root ' : '', "span");
  const infoParts = ["op: ".concat(op), "name: ".concat(description), "ID: ".concat(spanId)];
  if (parentSpanId) {
    infoParts.push("parent ID: ".concat(parentSpanId));
  }
  if (!isRootSpan) {
    const {
      op,
      description
    } = spanToJSON(rootSpan);
    infoParts.push("root ID: ".concat(rootSpan.spanContext().spanId));
    if (op) {
      infoParts.push("root op: ".concat(op));
    }
    if (description) {
      infoParts.push("root description: ".concat(description));
    }
  }
  logger.log("".concat(header, "\n  ").concat(infoParts.join('\n  ')));
}

/**
 * Print a log message for an ended span.
 */
function logSpanEnd(span) {
  if (!DEBUG_BUILD) return;
  const {
    description = '< unknown name >',
    op = '< unknown op >'
  } = spanToJSON(span);
  const {
    spanId
  } = span.spanContext();
  const rootSpan = getRootSpan(span);
  const isRootSpan = rootSpan === span;
  const msg = "[Tracing] Finishing \"".concat(op, "\" ").concat(isRootSpan ? 'root ' : '', "span \"").concat(description, "\" with ID ").concat(spanId);
  logger.log(msg);
}
export { logSpanEnd, logSpanStart };